import React from 'react';
import NotAvailable from '../Common/NotAvailable';

interface CalculationPopupProps {
  isOpen: boolean;
  onComplete: () => void;
}

// The wizard shows no score: a CLOUT score is calculated from the saved profile,
// endorsements, certifications and reviews, none of which exist before signup.
const CalculationPopup: React.FC<CalculationPopupProps> = ({ isOpen, onComplete }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 sm:p-8 max-w-md w-full text-center">
        <h3 className="font-['Ovo',_serif] text-[20px] sm:text-[24px] text-[#1f1f1f] mb-2">
          Your CLOUT Score
        </h3>
        <p className="mb-4">
          <NotAvailable className="text-[16px] sm:text-[18px]" />
        </p>
        <p className="font-['Ovo',_serif] text-[14px] sm:text-[16px] text-[#767472] mb-6">
          Your score is calculated once you create your account, from your profile, endorsements,
          certifications and reviews.
        </p>
        <button
          onClick={onComplete}
          className="w-full px-6 py-3 bg-[#1f1f1f] text-white font-['Ovo',_serif] text-sm uppercase hover:bg-[#333333] transition-colors"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default CalculationPopup;
